import Vue from 'vue'
import Buefy from 'buefy'
import App from './App.vue'
// import { http } from './services/api.service'
import router from './router'
import store from './store'

// 3rd parties
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'

// import jwtDecode from 'jwt-decode'

import { LicenseManager } from 'ag-grid-enterprise'

// Vee Validate
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate'
import veeValidateFr from 'vee-validate/dist/locale/fr.json'
import * as rules from 'vee-validate/dist/rules'

// Plugins
import BrowserPush from './services/browserPush.service'

// AG Grid
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-balham.css'

import Notifications from 'vt-notifications'

// Buefy
// import 'buefy/dist/buefy.css'

import VueTailwind from 'vue-tailwind'
import {
  TDatepicker,
  TDialog,
  TTextarea,
  TDropdown,
  TToggle,
  TRichSelect,
  TSelect,
  TButton,
  TCheckbox,
  TInputGroup,
  TInput,
  TModal,
  TTag
} from 'vue-tailwind/dist/components'
import French from 'vue-tailwind/dist/l10n/fr'

// Quill Editor
import VueQuillEditor from 'vue-quill-editor'
import Quill from 'quill'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import { normalizeQuillLink } from '@/utils/internalContentLinks'

// FontAwesome
// import '@fortawesome/fontawesome-pro/css/all.css'
// import '@fortawesome/fontawesome-pro/js/all.js'

import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

import './assets/scss/_variables.scss'

import './assets/index.css'
import './assets/tracking.css'
import './quill/registerAccordion'

document.title = process.env.VUE_APP_TITLE

LicenseManager.setLicenseKey('CompanyName=ANS,LicensedApplication=Observatoire eSante,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=1,AssetReference=AG-035649,SupportServicesEnd=8_December_2023_[v2]_MTcwMTk5MzYwMDAwMA==0721f6a891f16feac97e805692714cb3')

Vue.prototype.$store = store
Vue.config.productionTip = false

// Vue.prototype.$http = http

// Fix HTTP response format
/*
Vue.prototype.$http.interceptors.response.use(
  (response) => { return response },
  (error) => { return Promise.reject(error.response) }
)

// Add Authorization header to every HTTP request
if (store.getters.isLoggedIn) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('maviepro-jwt')
}
*/

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
localize('fr', veeValidateFr)

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

Vue.filter('toDateTime', function (value) {
  if (!value) return ''
  value = value.toString()
  return format(Date.parse(value), 'dd/MM/yyyy HH:mm', { locale: fr })
})

Vue.filter('toDate', function (value) {
  if (!value) return ''
  value = value.toString()
  return format(Date.parse(value), 'dd/MM/yyyy', { locale: fr })
})

// const token = localStorage.getItem('maviepro-jwt')

// if (typeof token !== 'undefined' && token !== null) {
//   console.log('jwt', jwtDecode(token))
// }

// Buefy setup
Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

// Quill RTE setupmai 22, 2023
Vue.use(Notifications)

Vue.use(VueQuillEditor)

// Keep every supported internal resource root-relative and complete bare external URLs.
const Link = Quill.import('formats/link')
class CustomLink extends Link {
  static sanitize (value) {
    return Link.sanitize(normalizeQuillLink(value))
  }
}
Quill.register('formats/link', CustomLink)
//

const vueTailwindSettings = {
  't-input': {
    component: TInput,
    props: {
      fixedClasses: 'block w-full px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
      classes: 'mt-2 flex w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-900 sm:text-sm sm:leading-6',
      variants: {
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900'
      }
    }
  },
  't-dialog': {
    component: TDialog,
    props: {
      fixedClasses: {
        overlay: 'content-confirmation-dialog-overlay overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center justify-center',
        wrapper: 'relative mx-auto',
        modal: 'overflow-visible relative',
        close: 'flex items-center justify-center',
        dialog: 'overflow-visible relative'
      }
    }
  },
  't-input-group': {
    component: TInputGroup,
    props: {
      fixedClasses: {
        wrapper: '',
        label: 'mb-1',
        body: '',
        feedback: ' text-sm',
        description: 'text-gray-400 text-sm'
      },
      classes: {
        wrapper: '',
        label: 'block font-medium leading-6 text-gray-900',
        body: '',
        feedback: 'text-gray-400',
        description: 'text-gray-400'
      },
      variants: {
        invert: {
          label: 'block text-sm font-medium leading-6 text-white'
        },
        danger: {
          label: 'block text-red-500',
          feedback: 'text-red-500'
        },
        success: {
          label: 'block text-green-500',
          feedback: 'text-green-500'
        },
        noMargin: {
          label: 'inline'
        }
      }
    }
  },
  't-checkbox': {
    component: TCheckbox,
    props: {
      fixedClasses: 'transition duration-100 ease-in-out rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
      classes: 'text-blue-500 border-gray-300 ',
      variants: {
        error: 'text-red-500 border-red-300',
        success: 'text-green-500 border-green-300'
      }
    }
  },
  't-select': {
    component: TSelect,
    props: {
      fixedClasses: 'block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
      classes: 'text-black placeholder-gray-400 bg-white border-gray-300 focus:border-blue-500 ',
      variants: {
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900'
      }
    }
  },
  't-textarea': {
    component: TTextarea,
    props: {
      fixedClasses: 'block w-full px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
      classes: 'text-black placeholder-gray-400 bg-white border-gray-300 focus:border-blue-500 ',
      variants: {
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900'
      }
    }
  },
  't-button': {
    component: TButton,
    props: {
      fixedClasses: 'block px-4 py-2 transition duration-100 ease-in-out focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
      classes: 'text-white bg-blue-500 border border-transparent shadow-sm rounded hover:bg-blue-600',
      variants: {
        disabled: 'text-white bg-blue-300 border border-transparent shadow-sm rounded cursor-not-allowed',
        secondary: 'border-2 border-grey-300 px-3 py-2 rounded shadow-sm hover:bg-grey-300',
        error: 'text-white bg-red-600 border border-transparent ring-1 ring-red-200 rounded shadow-sm hover:bg-red-700',
        success: 'text-white bg-green-600 border border-transparent ring-1 ring-green-200 rounded shadow-sm hover:bg-green-700',
        link: 'text-blue-500 underline hover:text-blue-600'
      }
    }
  },
  't-datepicker': {
    component: TDatepicker,
    props: {
      locale: French,
      fixedClasses: {
        navigator: 'flex',
        navigatorViewButton: 'flex items-center',
        navigatorViewButtonIcon: 'flex-shrink-0 h-5 w-5',
        navigatorViewButtonBackIcon: 'flex-shrink-0 h-5 w-5',
        navigatorLabel: 'flex items-center py-1',
        navigatorPrevButtonIcon: 'h-6 w-6 inline-flex',
        navigatorNextButtonIcon: 'h-6 w-6 inline-flex',
        inputWrapper: 'relative',
        viewGroup: 'inline-flex flex-wrap',
        view: 'w-64',
        calendarDaysWrapper: 'grid grid-cols-7',
        calendarHeaderWrapper: 'grid grid-cols-7',
        monthWrapper: 'grid grid-cols-4',
        yearWrapper: 'grid grid-cols-4',
        input: 'block w-full px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
        clearButton: 'flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6',
        clearButtonIcon: 'fill-current h-3 w-3'
      },
      classes: {
        wrapper: 'flex flex-col',
        dropdownWrapper: 'relative z-10',
        dropdown: 'origin-top-left absolute rounded shadow bg-white overflow-hidden mt-1',
        enterClass: 'opacity-0 scale-95',
        enterActiveClass: 'transition transform ease-out duration-100',
        enterToClass: 'opacity-100 scale-100',
        leaveClass: 'opacity-100 scale-100',
        leaveActiveClass: 'transition transform ease-in duration-75',
        leaveToClass: 'opacity-0 scale-95',
        inlineWrapper: '',
        inlineViews: 'rounded bg-white border mt-1 inline-flex',
        inputWrapper: '',
        input: 'text-black placeholder-gray-400 border-gray-300 mb-0',
        clearButton: 'hover:bg-gray-100 rounded transition duration-100 ease-in-out text-gray-600',
        clearButtonIcon: '',
        viewGroup: '',
        view: '',
        navigator: 'pt-2 px-3',
        navigatorViewButton: 'transition ease-in-out duration-100 inline-flex cursor-pointer rounded-full px-2 py-1 -ml-1 hover:bg-gray-100',
        navigatorViewButtonIcon: 'fill-current text-gray-400',
        navigatorViewButtonBackIcon: 'fill-current text-gray-400',
        navigatorViewButtonMonth: 'text-gray-700 font-semibold',
        navigatorViewButtonYear: 'text-gray-500 ml-1',
        navigatorViewButtonYearRange: 'text-gray-500 ml-1',
        navigatorLabel: 'py-1',
        navigatorLabelMonth: 'text-gray-700 font-semibold',
        navigatorLabelYear: 'text-gray-500 ml-1',
        navigatorPrevButton: 'transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-100 rounded-full p-1 ml-2 ml-auto disabled:opacity-50 disabled:cursor-not-allowed',
        navigatorNextButton: 'transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-100 rounded-full p-1 -mr-1 disabled:opacity-50 disabled:cursor-not-allowed',
        navigatorPrevButtonIcon: 'text-gray-400',
        navigatorNextButtonIcon: 'text-gray-400',
        calendarWrapper: 'px-3 pt-2',
        calendarHeaderWrapper: '',
        calendarHeaderWeekDay: 'uppercase text-xs text-gray-500 w-8 h-8 flex items-center justify-center',
        calendarDaysWrapper: '',
        calendarDaysDayWrapper: 'w-full h-8 flex flex-shrink-0 items-center',
        otherMonthDay: 'text-sm rounded-full w-8 h-8 mx-auto hover:bg-blue-100 text-gray-400 disabled:opacity-50 disabled:cursor-not-allowed',
        emptyDay: '',
        inRangeFirstDay: 'text-sm bg-blue-500 text-white w-full h-8 rounded-l-full',
        inRangeLastDay: 'text-sm bg-blue-500 text-white w-full h-8 rounded-r-full',
        inRangeDay: 'text-sm bg-blue-200 w-full h-8 disabled:opacity-50 disabled:cursor-not-allowed',
        selectedDay: 'text-sm rounded-full w-8 h-8 mx-auto bg-blue-500 text-white disabled:opacity-50 disabled:cursor-not-allowed',
        activeDay: 'text-sm rounded-full bg-blue-100 w-8 h-8 mx-auto disabled:opacity-50 disabled:cursor-not-allowed',
        highlightedDay: 'text-sm rounded-full bg-blue-200 w-8 h-8 mx-auto disabled:opacity-50 disabled:cursor-not-allowed',
        day: 'text-sm rounded-full w-8 h-8 mx-auto hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed',
        today: 'text-sm rounded-full w-8 h-8 mx-auto hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed border border-blue-500',
        monthWrapper: 'px-3 pt-2',
        selectedMonth: 'text-sm rounded w-full h-12 mx-auto bg-blue-500 text-white',
        activeMonth: 'text-sm rounded w-full h-12 mx-auto bg-blue-100',
        month: 'text-sm rounded w-full h-12 mx-auto hover:bg-blue-100',
        yearWrapper: 'px-3 pt-2',
        year: 'text-sm rounded w-full h-12 mx-auto hover:bg-blue-100',
        selectedYear: 'text-sm rounded w-full h-12 mx-auto bg-blue-500 text-white',
        activeYear: 'text-sm rounded w-full h-12 mx-auto bg-blue-100',
        timepickerWrapper: 'flex items-center px-4 py-2 space-x-2',
        timepickerTimeWrapper: 'flex items-center space-x-2',
        timepickerTimeFieldsWrapper: 'bg-gray-100 rounded-md w-full text-right flex items-center border border-gray-100 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        timepickerOkButton: 'text-blue-600 text-sm uppercase font-semibold transition duration-100 ease-in-out border border-transparent focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 rounded cursor-pointer',
        timepickerInput: 'text-center w-8 border-transparent bg-transparent p-0 h-6 text-sm transition duration-100 ease-in-out border border-transparent focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 rounded',
        timepickerTimeLabel: 'flex-grow text-sm text-gray-500',
        timepickerAmPmWrapper: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out bg-gray-100 border border-transparent rounded cursor-pointer focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        timepickerAmPmWrapperChecked: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out bg-gray-100 border border-transparent rounded cursor-pointer focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        timepickerAmPmWrapperDisabled: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out opacity-50 cursor-not-allowed',
        timepickerAmPmWrapperCheckedDisabled: 'relative inline-flex flex-shrink-0 transition duration-200 ease-in-out opacity-50 cursor-not-allowed',
        timepickerAmPmButton: 'absolute flex items-center justify-center w-6 h-6 text-xs text-gray-800 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded shadow',
        timepickerAmPmButtonChecked: 'absolute flex items-center justify-center w-6 h-6 text-xs text-gray-800 transition duration-200 ease-in-out transform translate-x-full bg-white rounded shadow',
        timepickerAmPmCheckedPlaceholder: 'flex items-center justify-center w-6 h-6 text-xs text-gray-500 rounded-sm',
        timepickerAmPmUncheckedPlaceholder: 'flex items-center justify-center w-6 h-6 text-xs text-gray-500 rounded-sm'
      },
      variants: {
        danger: {
          input: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
          clearButton: 'hover:bg-red-200 text-red-500'
        },
        dropup: {
          dropdownWrapper: 'relative z-40',
          dropdown: 'origin-bottom-left absolute bottom-full left-0 mb-2 rounded shadow bg-white overflow-hidden'
        },
        // Calendrier de la charte : texte 14 px gris (#4B5563), liseré et croix
        // bleu clair (#BFDBFE), jour choisi blanc sur bleu électrique (#2563EB).
        // Tailwind 2.2 : pas de slate-*, d'opacités /20 ni de valeurs [arbitraires].
        dashboard: {
          dropdownWrapper: 'relative z-30',
          dropdown: 'origin-top-right right-0 absolute mt-2 rounded-xl border border-blue-200 bg-white shadow-lg overflow-hidden',
          navigator: 'pt-3 px-4 text-gray-600',
          navigatorViewButton: 'transition ease-in-out duration-150 inline-flex cursor-pointer rounded-full px-3 py-1 text-sm text-gray-600 hover:bg-blue-50',
          navigatorPrevButton: 'transition ease-in-out duration-150 inline-flex cursor-pointer rounded-full p-1 ml-auto text-gray-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed',
          navigatorNextButton: 'transition ease-in-out duration-150 inline-flex cursor-pointer rounded-full p-1 -mr-1 text-gray-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed',
          calendarWrapper: 'px-4 pt-3 pb-4 text-gray-600',
          calendarHeaderWeekDay: 'uppercase text-xs text-gray-600 w-8 h-8 flex items-center justify-center',
          calendarDaysDayWrapper: 'w-full h-8 flex flex-shrink-0 items-center',
          day: 'text-sm rounded-full w-8 h-8 mx-auto text-gray-600 hover:bg-blue-50',
          inRangeDay: 'text-sm bg-blue-50 w-full h-8 rounded text-blue-600',
          inRangeFirstDay: 'text-sm bg-blue-600 text-white w-full h-8 rounded-l-full',
          inRangeLastDay: 'text-sm bg-blue-600 text-white w-full h-8 rounded-r-full',
          selectedDay: 'text-sm rounded-full w-8 h-8 mx-auto bg-blue-600 text-white shadow',
          today: 'text-sm rounded-full w-8 h-8 mx-auto border border-blue-200 text-blue-600',
          input: 'text-white placeholder-indigo-200/70 bg-transparent border-transparent mb-0 text-[0.75rem] tracking-[0.12em] uppercase focus:border-white/60 focus:ring-0 focus:outline-none focus:ring-offset-0',
          clearButton: 'hover:bg-blue-50 rounded transition duration-150 ease-in-out text-blue-200'
        },
        dashboardGlass: {
          dropdownWrapper: 'relative z-30',
          dropdown: 'origin-top-right right-0 absolute mt-2 rounded-xl border border-indigo-100/60 bg-white/75 backdrop-blur-lg shadow-lg overflow-hidden',
          navigator: 'pt-3 px-4 text-slate-600',
          navigatorViewButton: 'transition ease-in-out duration-150 inline-flex cursor-pointer rounded-full px-3 py-1 text-slate-600 hover:bg-indigo-50/70',
          navigatorPrevButton: 'transition ease-in-out duration-150 inline-flex cursor-pointer rounded-full p-1 ml-auto text-slate-500 hover:bg-indigo-50/80 disabled:opacity-50 disabled:cursor-not-allowed',
          navigatorNextButton: 'transition ease-in-out duration-150 inline-flex cursor-pointer rounded-full p-1 -mr-1 text-slate-500 hover:bg-indigo-50/80 disabled:opacity-50 disabled:cursor-not-allowed',
          calendarWrapper: 'px-4 pt-3 pb-4 text-slate-700',
          calendarHeaderWeekDay: 'uppercase text-[0.65rem] text-slate-400 w-8 h-8 flex items-center justify-center',
          calendarDaysDayWrapper: 'w-full h-8 flex flex-shrink-0 items-center',
          day: 'text-sm rounded-full w-8 h-8 mx-auto text-slate-600 hover:bg-indigo-500/20',
          inRangeDay: 'text-sm bg-indigo-500/20 w-full h-8 rounded text-indigo-600',
          inRangeFirstDay: 'text-sm bg-indigo-500 text-white w-full h-8 rounded-l-full',
          inRangeLastDay: 'text-sm bg-indigo-500 text-white w-full h-8 rounded-r-full',
          selectedDay: 'text-sm rounded-full w-8 h-8 mx-auto bg-indigo-500 text-white shadow',
          today: 'text-sm rounded-full w-8 h-8 mx-auto border border-indigo-400 text-indigo-600',
          input: 'text-white placeholder-indigo-200/70 bg-transparent border-transparent mb-0 text-[0.75rem] tracking-[0.12em] uppercase focus:border-white/60 focus:ring-0 focus:outline-none focus:ring-offset-0',
          clearButton: 'hover:bg-indigo-500/20 rounded transition duration-150 ease-in-out text-indigo-300'
        }
      }
    }
  },
  't-toggle': {
    component: TToggle,
    props: {
      fixedClasses: {
        wrapper: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200',
        wrapperChecked: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200  border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        wrapperDisabled: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200 opacity-50 cursor-not-allowed',
        wrapperCheckedDisabled: 'relative inline-flex flex-shrink-0 cursor-pointer transition-colors ease-in-out duration-200 opacity-50 cursor-not-allowed border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        button: 'inline-block absolute transform translate-x-0 transition ease-in-out duration-200',
        buttonChecked: 'inline-block absolute transform translate-x-full transition ease-in-out duration-200',
        checkedPlaceholder: 'inline-block',
        uncheckedPlaceholder: 'inline-block'
      },
      classes: {
        wrapper: 'bg-gray-400 rounded-full border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        wrapperChecked: 'bg-blue-500 rounded-full',
        wrapperDisabled: 'bg-gray-200 rounded-full border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        wrapperCheckedDisabled: 'bg-blue-500',
        button: 'h-5 w-5 rounded-full bg-white shadow flex items-center justify-center text-gray-400 text-xs',
        buttonChecked: 'h-5 w-5 rounded-full bg-white shadow flex items-center justify-center text-blue-500 text-xs',
        checkedPlaceholder: 'rounded-full w-5 h-5 flex items-center justify-center text-gray-400 text-xs',
        uncheckedPlaceholder: 'rounded-full w-5 h-5 flex items-center justify-center text-gray-400 text-xs'
      },
      variants: {
        danger: {
          wrapperChecked: 'bg-red-500 rounded-full',
          wrapperCheckedDisabled: 'bg-red-500 rounded-full'
        },
        success: {
          wrapperChecked: 'bg-green-500 rounded-full',
          wrapperCheckedDisabled: 'bg-green-500 rounded-full'
        },
        box: {
          wrapper: 'bg-gray-100 rounded-sm border-2 border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
          wrapperChecked: 'bg-blue-500 rounded-sm',
          wrapperCheckedDisabled: 'bg-blue-500 rounded-sm',
          button: 'h-6 w-6 rounded-sm bg-white shadow flex items-center justify-center text-gray-400 text-xs',
          buttonChecked: 'h-6 w-6 rounded-sm  bg-white shadow flex items-center justify-center text-blue-500 text-xs',
          checkedPlaceholder: 'rounded-sm w-6 h-6 flex items-center justify-center text-gray-400 text-xs',
          uncheckedPlaceholder: 'rounded-sm w-6 h-6 flex items-center justify-center text-gray-400 text-xs'
        }
      }
    }
  },
  't-dropdown': {
    component: TDropdown,
    props: {
      locale: French,
      fixedClasses: {
        button: 'flex items-center text-white block px-4 py-2 transition duration-100 ease-in-out border border-transparent rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
        wrapper: 'inline-flex flex-col',
        dropdownWrapper: 'relative z-10',
        dropdown: 'bg-white absolute w-56 rounded shadow mt-1',
        enterClass: 'opacity-0 scale-95',
        enterActiveClass: 'transition transform ease-out duration-100',
        enterToClass: 'opacity-100 scale-100',
        leaveClass: 'opacity-100 scale-100',
        leaveActiveClass: 'transition transform ease-in duration-75',
        leaveToClass: 'opacity-0 scale-95'
      },
      classes: {
        button: 'bg-blue-500 hover:bg-blue-600',
        dropdown: 'origin-top-left absolute left-0'
      },
      variants: {
        danger: {
          button: 'bg-red-500 hover:bg-red-600',
          dropdown: 'bg-red-50'
        },
        rightside: {
          dropdown: 'bg-white origin-top-right absolute right-0'
        }
      }
    }
  },
  't-rich-select': {
    component: TRichSelect,
    props: {
      fixedClasses: {
        wrapper: 'relative',
        buttonWrapper: 'inline-block relative w-full',
        selectButton: 'w-full flex text-left justify-between items-center px-3 py-2 text-black transition duration-100 ease-in-out border rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
        selectButtonLabel: 'block truncate',
        selectButtonPlaceholder: 'block truncate',
        selectButtonIcon: 'fill-current flex-shrink-0 ml-1 h-4 w-4',
        selectButtonClearButton: 'rounded flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6 transition duration-100 ease-in-out',
        selectButtonClearIcon: 'fill-current h-3 w-3',
        dropdown: 'absolute w-full z-10 -mt-1 absolute border-b border-l border-r rounded-b shadow-sm z-10',
        dropdownFeedback: '',
        loadingMoreResults: '',
        optionsList: 'overflow-auto',
        searchWrapper: 'inline-block w-full',
        searchBox: 'inline-block w-full',
        optgroup: '',
        option: 'cursor-pointer',
        disabledOption: 'opacity-50 cursor-not-allowed',
        highlightedOption: 'cursor-pointer',
        selectedOption: 'cursor-pointer',
        selectedHighlightedOption: 'cursor-pointer',
        optionContent: '',
        optionLabel: 'truncate block',
        selectedIcon: 'fill-current h-4 w-4',
        enterClass: '',
        enterActiveClass: '',
        enterToClass: '',
        leaveClass: '',
        leaveActiveClass: '',
        leaveToClass: ''
      },
      classes: {
        wrapper: '',
        buttonWrapper: '',
        selectButton: 'bg-white border-gray-300',
        selectButtonLabel: '',
        selectButtonPlaceholder: 'text-gray-400',
        selectButtonIcon: 'text-gray-600',
        selectButtonClearButton: 'hover:bg-blue-100 text-gray-600',
        selectButtonClearIcon: '',
        dropdown: 'bg-white border-gray-300',
        dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
        loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
        optionsList: '',
        searchWrapper: 'p-2 placeholder-gray-400',
        searchBox: 'px-3 py-2 bg-gray-50 text-xs rounded border focus:outline-none focus:shadow-outline border-gray-300',
        optgroup: 'text-gray-400 uppercase text-xs py-1 px-2 font-semibold',
        option: '',
        disabledOption: '',
        highlightedOption: 'bg-blue-100',
        selectedOption: 'font-semibold bg-gray-100 bg-blue-500 font-semibold text-white',
        selectedHighlightedOption: 'font-semibold bg-gray-100 bg-blue-600 font-semibold text-white',
        optionContent: 'flex justify-between items-center px-3 py-2',
        optionLabel: '',
        selectedIcon: '',
        enterClass: 'opacity-0',
        enterActiveClass: 'transition ease-out duration-100',
        enterToClass: 'opacity-100',
        leaveClass: 'opacity-100',
        leaveActiveClass: 'transition ease-in duration-75',
        leaveToClass: 'opacity-0',
        selectButtonTagWrapper: 'flex flex-wrap overflow-hidden',
        selectButtonTag: 'bg-blue-500 block disabled:cursor-not-allowed disabled:opacity-50 duration-100 ease-in-out focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded shadow-sm text-sm text-white transition white-space-no m-0.5 max-w-full overflow-hidden h-8 flex items-center',
        selectButtonTagText: 'px-3',
        selectButtonTagDeleteButton: '-ml-1.5 h-full hover:bg-blue-600 hover:shadow-sm inline-flex items-center px-2 transition',
        selectButtonTagDeleteButtonIcon: 'w-3 h-3'
      },
      variants: {
        danger: {
          selectButton: 'border-red-300 bg-red-50 text-red-900',
          selectButtonPlaceholder: 'text-red-200',
          selectButtonIcon: 'text-red-500',
          selectButtonClearButton: 'hover:bg-red-200 text-red-500',
          dropdown: 'bg-red-50 border-red-300'
        },
        success: {
          selectButton: 'border-green-300 bg-green-50 text-green-900',
          selectButtonIcon: 'text-green-500',
          selectButtonClearButton: 'hover:bg-green-200 text-green-500',
          dropdown: 'bg-green-50 border-green-300'
        },
        domainSelect: {
          wrapper: 'relative w-full'
        }
      }
    }
  },
  't-modal': {
    component: TModal,
    props: {
      fixedClasses: {
        overlay: 'z-40  overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-50',
        wrapper: 'relative mx-auto z-50 max-w-lg px-3 py-12',
        modal: 'overflow-visible relative  rounded',
        body: '',
        header: 'border-b p-3 rounded-t',
        footer: ' p-3 rounded-b',
        close: 'flex items-center justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50'
      },
      classes: {
        overlay: 'bg-black',
        wrapper: '',
        modal: 'bg-white shadow',
        body: 'p-3',
        header: 'border-gray-100',
        footer: 'bg-gray-100',
        close: 'bg-gray-100 text-gray-600 hover:bg-gray-200',
        closeIcon: 'fill-current h-4 w-4',
        overlayEnterClass: 'opacity-0',
        overlayEnterActiveClass: 'transition ease-out duration-100',
        overlayEnterToClass: 'opacity-100',
        overlayLeaveClass: 'opacity-100',
        overlayLeaveActiveClass: 'transition ease-in duration-75',
        overlayLeaveToClass: 'opacity-0',
        enterClass: '',
        enterActiveClass: '',
        enterToClass: '',
        leaveClass: '',
        leaveActiveClass: '',
        leaveToClass: ''
      },
      variants: {
        contentForm: {
          wrapper: 'mt-20 px-4 md:px-24 max-w-full z-50 relative mx-auto',
          body: ''
        },
        articleForm: {
          overlay: 'content-editor-modal-overlay',
          wrapper: 'min-h-screen px-3 md:px-4 py-4 w-full max-w-6xl z-50 relative mx-auto flex items-center justify-center',
          modal: 'w-full bg-transparent shadow-none',
          body: 'w-full p-0'
        },
        smallModal: {
          wrapper: 'mt-20 px-6 max-w-sm z-50 relative mx-auto',
          body: 'p-4'
        }
      }
    }
  },
  't-tag': {
    component: TTag,
    props: {
      fixedClasses: '',
      classes: '',
      variants: {
        title: 'text-2xl leading-8 font-extrabold text-gray-900 tracking-tight',
        subtitle: 'text-lg leading-6 font-medium text-gray-900',
        error: 'text-red-500',
        badge: 'inline-flex items-center px-3 rounded-full text-xs font-medium leading-4 bg-gray-100 text-gray-800',
        avatar: 'inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500 overflow-hidden leading-none text-center'
      }
    }
  }
}
Vue.use(VueTailwind, vueTailwindSettings)

Vue.use(FloatingVue)

// Install browserPush last, because it requires Buefy components
Vue.use(BrowserPush)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
